export const WITHDRAWAL_AUDIT_EVENTS = [
    'WITHDRAWAL_DOCUMENT_CREATED',
    'WITHDRAWAL_DOCUMENT_AUTO_CREATED',
    'WITHDRAWAL_DOCUMENT_COMPLETED',
    'WITHDRAWAL_DOCUMENT_REJECTED',
] as const;

export type WithdrawalAuditEventType = typeof WITHDRAWAL_AUDIT_EVENTS[number];

export interface WithdrawalAuditEntry {
    eventId: string;
    eventType: WithdrawalAuditEventType;
    eventTimestamp: string;
    userId?: string;
    userFullName?: string;
    userRole?: string;
    clientId?: number;
    organizationId?: number;
    organizationName?: string;
    organizationTin?: string;
    ipAddress?: string;
    userAgent?: string;
    documentId?: string;
    withdrawalReason?: string;
    sourceFormation?: 'MANUAL' | 'AUTOMATIC';
    salesChannel?: string;
    supportingDocumentNumber?: string;
    supportingDocumentDate?: string;
    comment?: string;
    affectedCodesCount?: number;
    previousStatuses?: Array<{status: string; count: number}>;
    rejectionReason?: string;
    errorCode?: string;
    failedMarkingCodes?: string[];
}

export interface WithdrawalAuditParams {
    userFullName?: string;
    organizationName?: string;
    organizationTin?: string;
    eventType?: string;
    from?: string;
    to?: string;
    documentId?: string;
    withdrawalReason?: string;
    sourceFormation?: string;
    salesChannel?: string;
    page?: number;
    size?: number;
}

export interface WithdrawalAuditPage {
    data: WithdrawalAuditEntry[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
}
